import { useEffect, ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router';

import { useDispatcher } from '../../shared/hooks/index.js';
import { useNavigateWithQuery } from '../../shared/providers/index.js';
import { authActions, Selectors, LoginPopoverForms, RouterSelectors, routerActions } from '../../store/index.js';

const FormPaths: any = {
    '/signup': LoginPopoverForms.SIGNUP,
    '/login': LoginPopoverForms.LOGIN,
    '/forgot-password': LoginPopoverForms.FORGOT_PASSWORD,
};

interface Props {
    FormComponent: ComponentType<any>;
}

const AccountManagementForm: FC<Props> = ({ FormComponent }) => {
    const setDeeplink = useDispatcher(routerActions.SetDeeplink);
    const setLoginEmail = useDispatcher(authActions.SetLoginEmail);
    const setAccountFormError = useDispatcher(authActions.AccountFormError);
    const user = useSelector(Selectors.user);
    const deeplink = useSelector(RouterSelectors.deeplink);
    const navigate = useNavigateWithQuery();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const emailFromQuery = searchParams.get('em');
        if (emailFromQuery) {
            setLoginEmail(emailFromQuery);
        }
    }, [searchParams]);

    useEffect(() => {
        return () => {
            setDeeplink(undefined);
        };
    }, []);

    useEffect(() => {
        setAccountFormError();
    }, [location.pathname]);

    useEffect(() => {
        if (user) {
            // TODO: figure out how to properly deeplink on native
            if (!APP && deeplink) {
                // Using window.location instead of history to avoid issues with router-state-sync picking up url params
                navigate(decodeURIComponent(deeplink));
            } else {
                navigate('/feed');
            }
        }
    }, [user, deeplink, navigate]);

    const changeActiveForm = (form: string) => {
        Object.entries(FormPaths).forEach(([key, value]) => {
            if (form === value) {
                navigate(key);
            }
        });
    };

    return (
        <div className="account-management-form text-center">
            <FormComponent changeForm={changeActiveForm} />
        </div>
    );
};

export default AccountManagementForm;
